export const getArrayChange = (oldArr, newArr) => {
  const accumulator = {
    toDelete: [...oldArr],
    toAdd: [],
  };

  const { toDelete, toAdd } = newArr.reduce((acc, newItem) => {
    const oldArrIndex = acc.toDelete.indexOf(newItem);
    if (oldArrIndex !== -1) acc.toDelete.splice(oldArrIndex, 1);
    else acc.toAdd.push(newItem);
    return acc;
  }, accumulator);

  return {
    toDelete: toDelete.filter(Boolean),
    toAdd: toAdd.filter(Boolean),
  };
};

export const findNestedObj = (entireObj, keyToFind) => {
  let foundObj;
  JSON.stringify(entireObj, (_, nestedValue) => {
    if (nestedValue && nestedValue[keyToFind]) {
      foundObj = nestedValue;
    }
    return nestedValue;
  });
  return foundObj;
};
